import { colorMappings } from './colorMappings';

export function getColorByTemperature(temperature: number): string {
  const mapping = colorMappings.find(
    (mapping) =>
      temperature >= mapping.minTemperatur &&
      temperature <= mapping.maxTemperatur,
  );

  return mapping ? mapping.color : 'text-gray-500';
}
